import angular                from 'angular'
import angularGoogleAnalytics from 'angular-google-analytics'

let module = angular.module('googleAnalytics', [
  angularGoogleAnalytics
])

.config((AnalyticsProvider) => {
  'ngInject'
  AnalyticsProvider.useAnalytics(false)
  AnalyticsProvider.startOffline(true)
  AnalyticsProvider.setAccount([])
})

.run(($rootScope, Analytics, Localization, CookiesService) => {
  'ngInject'
  const account = {
    tracker: Localization.getLocalizedAppConfig().trackingIdGA,
    trackEvent: true
  }

  $rootScope.$on('cookieConsentUpdated', () => {
    let consentValue = CookiesService.consentForCookie('audienceMeasurement')
    Analytics.offline(!consentValue)
  })

  Analytics.configuration.accounts.push(account)
  Analytics.registerScriptTags()
  Analytics.registerTrackers()
  let consentForGa = CookiesService.consentForCookie('audienceMeasurement')
  Analytics.offline(!consentForGa)
})

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/google-analytics/index.js